import { redirect } from 'react-router-dom';
import { getParamsFromStoreRedux } from 'store/utils';

import {
  getPostFlowUrl,
  getReturnUrlFromRequestLoader,
} from 'utils/common/route';
import { ensureUserInfoLoaded } from 'utils/loaderUtils';

export const personalizationLoader =
  (queryClient) =>
  async ({ request }) => {
    const returnUrl = getReturnUrlFromRequestLoader(request) || '/';

    const { dispatch } = getParamsFromStoreRedux();

    const { userInfo } = await ensureUserInfoLoaded({
      queryClient,
      returnUrl,
    });

    const personal = userInfo?.personalInfo;
    if (personal) {
      const redirectUrl = getPostFlowUrl({
        type: 'personalization',
        returnUrl,
        dispatch,
      });
      throw redirect(redirectUrl);
    }

    return {
      personal: personal || {},
    };
  };
